import { client, clientWithoutErrorHandling } from '../http';

export default {
  async askCashflowAssistant(sessionId, currentInput) {
    const response = await client.post(
      '/api/ask-cashflow-assistant',
      { sessionId, currentInput },
    );
    return response.data;
  },

  async getConversations() {
    const response = await client.post('/api/chat-conversations');
    return response.data;
  },

  async getConversationMessages(conversationId) {
    const response = await client.post('/api/chat-conversation-messages', { conversationId });
    return response.data;
  },

  async submitCsat(conversationId, score, comment) {
    const response = await client.post('/api/chat-csat', { conversationId, score, comment });
    return response.data;
  },

  async getCsatRatings() {
    const response = await client.get('/api/chat-csat');
    return response.data;
  },

  async markConversationRead(conversationId) {
    const response = await client.post('/api/chat-mark-read', { conversationId });
    return response.data;
  },

  async deleteConversation(conversationId) {
    const response = await client.post('/api/chat-delete-conversation', { conversationId });
    return response.data;
  },

  async escalateConversation(conversationId) {
    const response = await client.post('/api/escalate-conversation', { conversationId });
    return response.data;
  },

  async startTeamConversation(initiator) {
    // Bounded: the client has no default timeout, and a stalled handover would
    // otherwise pin the customer on the loading screen with no Intercom fallback.
    const response = await clientWithoutErrorHandling.post('/api/start-team-conversation', { initiator }, { timeout: 20000 });
    return response.data;
  },
};
